//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { createExport } from '@/mixins/createExport';

export default {
    mixins: [createExport],
    props: ['type'],
    data: function data() {
        return {
            // loading: true,
            headers: ['First Name', 'Last Name', 'Unit', {
                title: 'Lease Expires',
                filter: 'dateFull'
            }, {
                title: 'Move In Date',
                filter: 'dateFull'
            }, {
                title: 'Move Out',
                filter: 'dateFull'
            }, {
                title: 'Rent Amount',
                filter: 'toCurrency'
            }],
            fields: ['full_first_name', 'person.last_name', 'unit.unit_label', 'lease_expiration_date', 'lease.move_in_date', 'move_out_date', 'unit.rent_amount']
        };
    },

    computed: {
        residents: function residents() {
            return this.$store.state.pastResidents;
        },
        loading: function loading() {
            return this.$store.state.isLoading;
        }
    },
    created: function created() {
        var $el = this;
        Event.$on('past-resident-list-updated', function () {
            $el.refresh();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('past-resident-list-updated');
    },
    mounted: function mounted() {
        this.$store.dispatch('getPastResidents');
    },

    methods: {
        exportReport: function exportReport() {
            this.loading = true;

            var data = {};

            this.createExport(data, '/prototype/properties/pastResidentsReport', 'past-resident', '.xlsx');

            this.loading = false;
        },
        refresh: function refresh() {
            this.$store.dispatch('getPastResidents');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/past-residents/PastResidentList.vue
// module id = Yvrg
// module chunks = 0 1